import PropTypes from 'prop-types';
import React from 'react';
import { RCT, FLUENCY } from '../../../../constants/measure';
import { MODELING } from '../../../../constants/assessmentItemType';
import AudioContainer from '../../../../common/audio/audioContainer';
import GoButton from '../../../../common/components/GoButton';
import SegmentedPassage from '../../../../common/components/SegmentedPassage';
import PopupQuestion from '../../../../common/components/PopupQuestion';
import TriangleButton from '../../../../common/components/TriangleButton';
import PassageLayout from '../../../../common/layouts/passageLayout';
import PassageTitle from '../../../../common/components/PassageTitle';

export default class RCTFluencyModelView extends React.Component {
    componentDidMount() {
        if (!this.props.isDataFetched) {
            this.props.fetchContent();
        } else {
            this.startScreenSequence();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isDataFetched && this.props.isDataFetched) {
            this.startScreenSequence();
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    startScreenSequence() {
        this.props.initPractice();
    }

    render() {
        return (
            <PassageLayout
                class={`${RCT}-${FLUENCY} ${MODELING}`}
                isScreenBlocked={this.props.isScreenBlocked}
                isGreyedOut={this.props.isGreyedOut}>
                <AudioContainer />
                <PassageTitle
                    subTitle="Practice text"
                    title={this.props.passageTitle} />
                <div className="page-wrapper">
                    <div className="fluency-wrapper">
                        {this.props.isDataFetched
                                && (
                                    <SegmentedPassage
                                        segments={this.props.segments}
                                        isActiveSegmentHidden={!this.props.isSegmentVisible}
                                        activeSegmentIndex={this.props.activeSegmentIndex}
                                        onShow={this.props.onSegmentShow} />
                                )}
                        <div className="fluency-questions">
                            {this.props.question
                                        && (
                                            <PopupQuestion
                                                question={this.props.question.stimulus.text}
                                                possibleResponses={
                                                    this.props.question.possibleResponses
                                                }
                                                onResponseSelected={this.props.onResponseSelected}
                                                selectedResponse={this.props.selectedResponse}
                                                isHidden={!this.props.isQuestionVisible}
                                                onHide={this.props.onPopupQuestionHide} />
                                        )}
                        </div>
                        <div
                            className={`fluency-overlay${this.props.isNextButtonActive
                                ? ' hide-horizontal-line' : ''}`}>
                            {!this.props.isNextButtonActive
                                    && (
                                        <TriangleButton
                                            style={this.props.isSegmentVisible}
                                            isEnabled={this.props.isDownButtonEnabled}
                                            onClick={this.props.onDownButtonClick} />
                                    ) }
                        </div>
                    </div>
                </div>
                {this.props.isNextButtonActive
                        && (
                            <GoButton
                                isEnabled={!this.props.isScreenBlocked}
                                onClick={this.props.onNextClick} />
                        ) }
            </PassageLayout>
        );
    }
}

RCTFluencyModelView.propTypes = {
    isDataFetched: PropTypes.bool,
    isGreyedOut: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isNextButtonActive: PropTypes.bool,
    isDownButtonEnabled: PropTypes.bool,
    isQuestionVisible: PropTypes.bool,
    isSegmentVisible: PropTypes.bool,
    segments: PropTypes.array,
    question: PropTypes.object,
    cleanup: PropTypes.func,
    fetchContent: PropTypes.func,
    onResponseSelected: PropTypes.func,
    initPractice: PropTypes.func,
    onDownButtonClick: PropTypes.func,
    onPopupQuestionHide: PropTypes.func,
    onSegmentShow: PropTypes.func,
    onNextClick: PropTypes.func,
    activeSegmentIndex: PropTypes.number,
    selectedResponse: PropTypes.number,
    passageTitle: PropTypes.string,
};

RCTFluencyModelView.defaultProps = {
    isDataFetched: false,
    isGreyedOut: false,
    isScreenBlocked: false,
    isNextButtonActive: false,
    isDownButtonEnabled: false,
    isQuestionVisible: false,
    isSegmentVisible: false,
    segments: [],
    question: undefined,
    cleanup: () => {},
    fetchContent: () => {},
    onResponseSelected: () => {},
    initPractice: () => {},
    onDownButtonClick: () => {},
    onPopupQuestionHide: () => {},
    onSegmentShow: () => {},
    onNextClick: () => {},
    activeSegmentIndex: undefined,
    selectedResponse: undefined,
    passageTitle: '',
};
